exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-ad2e182c]{background:#000;opacity:.7}.overlay-enter[data-v-ad2e182c],.overlay-leave-to[data-v-ad2e182c]{opacity:0}.overlay-enter-active[data-v-ad2e182c],.overlay-leave-active[data-v-ad2e182c]{transition:all .3s}", ""]);

// exports
